export const TetronLoadingIcon = () => {
  return (
    <svg
      width="264"
      height="108"
      viewBox="0 0 264 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="fillingUp" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0" stopColor="#009FDA">
            <animate
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="1"
            />
          </stop>
          <stop offset="0" stopColor="#EEEEEE">
            <animate
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="1"
              // fill="url(#fillingUp)"
            />
          </stop>
        </linearGradient>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.535 0L75.2338 55.1164H0L36.9329 0H113.535ZM187.398 0H263.999L225.699 55.1164H153.764C152.356 55.1164 151.518 53.5453 152.301 52.3755L187.398 0ZM113.538 108L150.471 55.1159L113.538 0.00266451L75.237 55.1169L113.538 108Z"
        //fill="#EEEEEE"
        fill="url(#fillingUp)"
      />
    </svg>
  )
}
